import React, { useEffect, useState } from 'react';

import { api } from 'services/api';

import styles from './styles.module.scss';

const AdminPage = () => {
  const [tab, setTab] = useState<'users' | 'pending' | 'analysis'>('users');
  const [users, setUsers] = useState<any[]>([]);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [vacancies, setVacancies] = useState<any[]>([]);
  const [applicationsLeftInput, setApplicationsLeftInput] = useState('');
  const [tasksPending, setTasksPending] = useState<any[]>([]);
  const [tasksAnalysis, setTasksAnalysis] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (tab === 'users') {
      api('admin/users').then(res => res.json()).then(setUsers).catch(e => setError('Error'));
    } else if (tab === 'pending') {
      api('admin/tasks-pending').then(res => res.json()).then(setTasksPending);
    } else if (tab === 'analysis') {
      api('admin/tasks-analysis').then(res => res.json()).then(setTasksAnalysis);
    }
  }, [tab]);

  const handleUserClick = (id: number) => {
    setSelectedUserId(id);
    api(`admin/users/${id}/vacancies`).then(res => res.json()).then(setVacancies);
  };

  const handleUpdateApplications = () => {
    if (!selectedUserId || !applicationsLeftInput) return;
    api(`admin/users/${selectedUserId}/applications-left`, {
      method: 'PATCH',
      body: JSON.stringify({ value: +applicationsLeftInput }),
    }).then(() => {
      alert('Значение успешно обновлено');
      setApplicationsLeftInput('');
    });
  };

  if (error) {
    return <div>Error</div>
  }

  return (
    <div className={styles.adminPage}>
      <div className={styles.tabs}>
        <button onClick={() => setTab('users')} className={tab === 'users' ? styles.active : ''}>Пользователи</button>
        <button onClick={() => setTab('pending')} className={tab === 'pending' ? styles.active : ''}>Tasks Pending</button>
        <button onClick={() => setTab('analysis')} className={tab === 'analysis' ? styles.active : ''}>Tasks Analysis</button>
      </div>

      {tab === 'users' && (
        <div className={styles.usersSection}>
          <h2>Пользователи</h2>
          <ul className={styles.userList}>
            {users.map(user => (
              <li key={user.id} onClick={() => handleUserClick(user.id)}>
                {user.email} (ID: {user.id}) — Осталось: {user.applications_left}
              </li>
            ))}
          </ul>

          {selectedUserId && (
            <div className={styles.userDetails}>
              <h3>Вакансии пользователя {selectedUserId}</h3>
              <ul>
                {vacancies.map(v => (
                  <li key={v.id}>{v.title}</li>
                ))}
              </ul>

              <div className={styles.updateForm}>
                <input
                  type="number"
                  placeholder="+ количество откликов"
                  value={applicationsLeftInput}
                  onChange={e => setApplicationsLeftInput(e.target.value)}
                />
                <button onClick={handleUpdateApplications}>Добавить отклики</button>
              </div>
            </div>
          )}
        </div>
      )}

      {tab === 'pending' && (
        <div>
          <h2>Tasks Pending</h2>
          <ul>
            {tasksPending.map(task => (
              <li key={task.id}>{task.full_name} — {task.email}</li>
            ))}
          </ul>
        </div>
      )}

      {tab === 'analysis' && (
        <div>
          <h2>Tasks Analysis</h2>
          <ul>
            {tasksAnalysis.map(task => (
              <li key={task.id}>{task.full_name} — {task.email}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default AdminPage;
